import { render, staticRenderFns } from "./PromotionEdit.vue?vue&type=template&id=4878471d&scoped=true&"
import script from "./PromotionEdit.vue?vue&type=script&lang=js&"
export * from "./PromotionEdit.vue?vue&type=script&lang=js&"
import style0 from "./PromotionEdit.vue?vue&type=style&index=0&id=4878471d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4878471d",
  null
  
)

export default component.exports